import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { toast } from 'react-toastify';
import { show as showLoader, hide as hideLoader } from '../components/loader/loaderSlice';
import { i18n } from './apiSlice';
export { default as i18n } from "../i18n"

const errorOnToast = (err) => {
  for (const key in err.errors) {
    for (const error of err.errors[key]) {
      toast.error(`${key} : ${error}`);
    }
  }
}

export const addLoader = () => async (id, { dispatch, queryFulfilled }) => {
  dispatch(showLoader())
  try {
    await queryFulfilled
  } finally {
    dispatch(hideLoader())
  }
}

export const asyncToastDisplay = ({successMessage}) => async (id, { dispatch, queryFulfilled }) => {
  dispatch(showLoader())
  try {
    await queryFulfilled
    toast.success(successMessage)
  } catch (err) {
    if (err.error.status == 422) {
      errorOnToast(err.error.data.error)
    } else  if (err.error.status == 403) {
      toast.error(i18n.t("toast.unauthorized"));
    } else {
      // toast.error(`${err.error.status} : ${err.error.data}`);
      toast.error("An error has occurred");
    }
  } finally {
    dispatch(hideLoader())
  }
}

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '/v1',
    prepareHeaders: (headers, _) => {
      const csrfToken = document.querySelector('[name=csrf-token]');
      if (csrfToken) {
        headers.set('X-CSRF-TOKEN', csrfToken.content);
      }
      return headers
    }
  }),
  tagTypes: [
    'AbRemoteStrategies',
    'Documentation',
    'Publisher',
    'LocationRequestConfig',
    'IdfaRequestConfig',
    'Invoice',
    'Publisher',
    'PublisherInvoice',
    'DataProduct',
    'DataVendor',
    'DataVendorReferences',
    'DataVendorStream',
    'DataVendorExtract',
    'Device',
    'Request',
    'DataVendorInvoice',
    'AggregationOptions',
    'Apps',
    'AppsAdmin',
    'Stream',
    'Extract',
    'Boundaries',
    'Pakito',
    'RemoteConfiguration',
    'RemoteConfigurationHistory',
    'Vendors',
    'Privacy',
    'Purposes',
    'AwsCreds',
    'Industry',
    'Restriction',
    'Zone',
    'User',
    'Dmp',
    'Role',
    'Audience',
    'PageElement',
    'DataVendorAudience',
    'CmpConfig',
    'AppGroup',
    'ConsentRequestLayout',
    'Oauth',
    'Dashboard',
    'SdkVersion',
    'SdkVersionNewsletterSubscriber',
    'ColumnMapping',
    'Search',
    'MotionModel',
    'CmpAnalytics'],
  endpoints: () => ({})
})
